<template>
<div>
    <testDiialog :data="methodsKind" ref="dailog" @change="change" />
    <export-excute-popper 
    v-if="exportTarget && showExportPopper" 
    @close="onclose"
    @change-target="changeTarget"
    :data="data"
    :target="exportTarget"
    ></export-excute-popper>
</div>

</template>
<script>
import exportExcutePopper from "@/code-lab/component/file-management/export-excute/export-excute-popper.vue"
import testDiialog from './testDiialog.vue'
import { mapState } from 'vuex'
export default {
    name: "export-excute",
    components: {
        exportExcutePopper,
        testDiialog
    },
    props: {
        data: Array
    },
    data(){
        return {
            visible: false,
            exportTarget: null,//quick-快速連線，rms-機器人管理系統 white 白名单
            showExportPopper: false,
            methodsKind: []
        }
    },
    computed: {
        ...mapState([
            "currentVersion",
            'userInfo'
        ])
    },
    watch: {
        visible(value){
            if(value){
                this.$nextTick(() => {
                //    closeQuick()
                //    closeRms()
                //    closeWhite()
                   this.$nextTick(() => {
                    this.startExport();
                   })
                });
            }
        }
    },
    methods: {
        change (tag) {
            console.log(tag, 'change')
            this.exportTarget = tag;
            this.showExportPopper = true;
        },
        startExport(){
            this.methodsKind = []
            //教师版和学生版才判断是否有rms和白名单连线
            if(['teacher', 'student'].includes(this.currentVersion)){
                if (this.userInfo.currentTeam.isBiz) {
                    this.methodsKind.push('white')
                }

                if (this.userInfo.currentTeam.isRmsScope) {
                    this.methodsKind.push('rms')
                }
            }
            
            if (this.methodsKind.length === 0) {
                this.methodsKind.push('quick')
            }

            if (this.methodsKind.length > 1) {
                this.$refs['dailog'].open()
            } else {
                this.exportTarget = this.methodsKind[0]
                this.showExportPopper = true
            }
        },
        showExortTargetPopper(next = () => {}){
            this.$confirm(this.$t("export_project.select_export_target"), this.$t("export_project.export_target_title"), {
                // dangerouslyUseHTMLString: true,
                closeOnPressEscape: false,
                cancelButtonClass: "export-pop-button gray",
                confirmButtonClass: "export-pop-button  gray",
                cancelButtonText: this.$t("export_project.target_rms"),
                confirmButtonText: this.$t("export_project.target_quick"),
                customClass: "export-excute-popper center select-target-popper",
                distinguishCancelAndClose: true,
                destroyOnClose: true
            }).then(() => {
                this.exportTarget = "quick";
                next();
            }).catch(action => {
                if(action === "cancel"){
                    this.exportTarget = "rms";
                    next();
                } else {
                    this.visible = false;
                }
            });
        },
        changeTarget(target){
            this.exportTarget = target;
        },
        onclose(){
            this.exportTarget = null;
            this.showExportPopper = false;
            this.visible = false;
            this.$emit("close");
        }
    }
}
</script>
<style lang="scss">
.el-message-box.export-excute-popper, .el-dialog.export-excute-popper{
    &.export-excute-popper{
        width: 460px;
    }
    background: #444444;
    // padding: 24px 36px;
    color: #ffffff;
    border-color: transparent;
    .el-message-box__header, .el-dialog__header{
        padding-left: 36px;
        .el-message-box__title, .el-dialog__title{
            color: #ffffff;
            line-height: 40px;
        }
    }
    .el-message-box__content, .el-dialog__body{
        min-width: 72px;
        padding: 0 40px 40px;
        color: #ffffff;
        font-size: 14px;
    }
    .el-message-box__btns{
        padding: 16px 36px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    &.center{
        .el-message-box__btns{
            justify-content: space-between;
        }
    }
}
.el-tooltip__popper.export-project-tooltip{
    width: 194px;
    padding: 6px;
    border: none;
    .toolti-content{
        width: 100%;
        overflow: hidden;
        color: #c8c8c8;
        font-size: 13px;
        line-height: 1.5em;
    }
    &.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
        border-bottom-color: #272727;
    }
    &.el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
        border-bottom-color: #272727;
    }
    &.el-tooltip__popper[x-placement^="top"] .popper__arrow {
        border-top-color: #272727;
    }
    &.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
        border-top-color: #272727;
    }
}
</style>